import { Button } from "@fluentui/react-components";
import { useContext } from "react";
import ApprovalService from "../../../services/ApprovalService";
import { ApprovalUserContext } from "../../../interfaces/ApprovalUserContext";
import { UserContext } from "../../../contexts/UserContext";
import { ErrorHandlingService } from "../../../services/ErrorHandlingService";
import { Checkmark16Filled } from "@fluentui/react-icons";
import { OrdersContext } from "../../../contexts/OrdersContext";
import { DecideSelectedButtonProps } from "../../../interfaces/DecideSelectedButtonProps";
import {
  LanguageStrings,
  useLocalization,
} from "../../../contexts/LocalizationContext";

function ApproveSelectedButton({
  overrideOnClick,
  comment = "Approved from approval app.",
  onClickCallback,
  disabled = false,
}: DecideSelectedButtonProps) {
  const userContext = useContext<ApprovalUserContext>(UserContext);
  const orderManagementContext = useContext(OrdersContext);
  const localized = useLocalization() as LanguageStrings;

  const onClickEvent = (e: React.MouseEvent<HTMLElement>) => {
    if (overrideOnClick) {
      overrideOnClick();
    } else {
      handleClick();
    }
    if (onClickCallback) {
      onClickCallback();
    }
    e.stopPropagation();
  };

  function handleClick() {
    let selectedObjectIds: string[] = [];
    orderManagementContext.orders.map((order) => {
      if (order.IsSelected) {
        selectedObjectIds = selectedObjectIds.concat(order.ObjectId);
      }
    });

    ApprovalService.approveMultipleOrders(
      userContext,
      selectedObjectIds,
      comment
    )
      .then(() => {
        orderManagementContext.popOrdersAfterDecide(selectedObjectIds);
      })
      .catch((error) => {
        ErrorHandlingService.handleApiError(error);
      });
  }

  if (orderManagementContext.numberOfSelectedOrders !== 0)
    return (
      <Button
        onClick={onClickEvent}
        appearance="primary"
        icon={<Checkmark16Filled />}
        disabled={disabled}
      >
        {localized.Approve} ({orderManagementContext.numberOfSelectedOrders})
      </Button>
    );
  else return <></>;
}

export default ApproveSelectedButton;
